<template><div><h1>VUX V2.0.14 released</h1>
<h2><a href="/en/components/grid.html">Grid</a></h2>
<ul><li>[feature] Add component `grid`</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.0.14 released | VUX - Vue.js Mobile UI Component Framework","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.0.14-68.vue?236862bb